import { memo, useContext } from "react";
import PropTypes from "prop-types";
import SmartDPProduct from "app/pages/SmartDP/Listing/SmartDPProduct/SmartDPProduct";
import classNames from "classnames";
import { BRANDS } from "app/constants";
import AppGlobalsContext from "app/AppGlobalsContext";
import { getIsDubaiProduct } from "app/utils/productUtils";

const SmartDPMapListItem = ({ data = {}, index, style = {} }) => {
	const { brand } = useContext(AppGlobalsContext);
	const accommodation = data.accommodationsList[index];
	const onAccommodationClick = data.onAccommodationClick;
	const spotlightAccommodationId = data.spotlightAccommodationId;
	const itemSelected = data.itemSelected;
	const onAccommodationHover = data.onAccommodationHover;
	const isDubaiProduct = getIsDubaiProduct(accommodation?.geography);
	const showEmiratesPassItem = brand === BRANDS.EK && isDubaiProduct;

	const smartDPProductClasses = classNames({
		"sdp-product-wrapper": true,
		"sdp-product--active": itemSelected === accommodation.name,
		"sdp-product__first--active": index === 0 && itemSelected === accommodation.name,
	});

	return (
		<div
			style={{ ...style, height: "auto" }}
			onMouseEnter={() => {
				onAccommodationHover(accommodation, index);
			}}
		>
			<div>
				<div className={smartDPProductClasses}>
					<SmartDPProduct
						position={index}
						isSpotlight={spotlightAccommodationId === String(accommodation?.id)}
						accommodation={accommodation}
						onClick={onAccommodationClick}
						orientation="horizontal"
						className={classNames("sdp-map-product-card", {
							"sdp-map-product-card--emirates-pass": showEmiratesPassItem,
						})}
						showBadgeSecondaryText={false}
					/>
				</div>
			</div>
		</div>
	);
};

SmartDPMapListItem.propTypes = {
	index: PropTypes.number,
	style: PropTypes.object,
	data: PropTypes.object,
};

export default memo(SmartDPMapListItem);
